<template>
  <el-dialog
    :visible.sync="milestoneDialogVisible"
    class="milestone-info-dialog"
    :title="$t('TankService.Singleticketsubscription')"
    width="950px"
    center
    append-to-body
    @open="onDialogOpen"
    @closed="afterDialogClosed"
  >
    <div>
      <el-form
        ref="milestoneForm"
        :model="milestoneForm"
        :rules="milestoneFormRules"
        :validate-on-rule-change="false"
        label-width="150px"
      >
        <el-row style="width: 900px">
          <el-col style="height: 60px">
            <el-form-item
              :label="$t('TankService.SubscriptionTheme')"
              prop="MailSubject"
            >
              <el-input
                v-model="milestoneForm.MailSubject"
                size="small"
                :maxlength="500"
                :placeholder="$t('TankService.Pleaseenterthecontent')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col style="height: 60px">
            <el-form-item
              :label="$t('TankService.Receivingemailaccount')"
              prop="MailTo"
            >
              <el-input
                v-model="milestoneForm.MailTo"
                size="small"
                :maxlength="500"
                :placeholder="$t('TankService.Content6')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col style="height: 60px">
            <el-form-item :label="$t('TankService.CCemailaccount')">
              <el-input
                v-model="milestoneForm.MailCC"
                size="small"
                :maxlength="500"
                :placeholder="$t('TankService.Content6')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item :label="$t('TankService.Content8')" :required="true">
              <el-card style="margin: 1px">
                <div class="order-step">
                  <div
                    class="order-step-item"
                    v-for="(item, index) in data"
                    :key="index"
                  >
                    <div class="satus-name">
                      <el-checkbox
                        class="checkbox"
                        v-model="checkedItems"
                        :label="item.key"
                        >{{ '' }}</el-checkbox
                      >
                      <div v-show="index < data.length - 1" class="flex">
                        <div
                          style="
                            width: 120px;
                            border-top: 1px solid;
                            margin-top: 6px;
                            bordercolor: #51abc3;
                          "
                        ></div>
                      </div>
                    </div>
                    <div class="status-time">{{ item.label }}</div>
                  </div>
                </div>
              </el-card>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <template #footer>
      <div>
        <el-button
          type="primary"
          :loading="submitLoading"
          size="medium"
          style="margin-right: 8px"
          @click="submitForm"
          >{{ $t('TankService.Submit') }}</el-button
        >
        <el-button
          :loading="submitLoading"
          size="medium"
          @click="milestoneDialogVisible = false"
          >{{ $t('TankService.Cancel') }}</el-button
        >
      </div>
    </template>
  </el-dialog>
</template>
<script>

import GMS_CODE from '@/assets/json/milestoneCode.json'
import { saveMilestoneMan, getMilestoneCodeList } from '@/api/gmsTank';
import i18n from '@/i18n/i18n'
export default {
  name: 'MilestoneTDDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    milestoneInfo: {
      type: Object,
      default: () => { },
    },
  },
  created() {
    // this.Job_TypeId = this.milestoneInfo.Job_TypeId;
    // this.getMilestoneCodeList()
  },
  data() {
    return {
      checkedItems: [], // 已选中项的值
      data: [],
      Job_TypeId: '',
      milestoneForm: {
        Booking_No: '',
        MailTo: '',
        MailCC: '',
        MailSubject: '',
        MailBody: '',
        SelectMltCode: '',
        Job_TypeId: '',
        CustomerCode: '',
        CustomerName: '',
      },
      submitLoading: false,
    };
  },
  mounted() {
  },
  computed: {
    milestoneDialogVisible: {
      get() {
        this.getMilestoneCodeList()
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      },
    },
    milestoneFormRules() {
      return {
        MailSubject: [
          { required: true, message: i18n.t('TankService.Content9'), trigger: 'blur' }
        ],
        MailTo: [
          { required: true, message: i18n.t('TankService.Content10'), trigger: 'blur' }
        ]
      };
    },
  },
  methods: {
    getMilestoneCodeList() {
      this.data = [];
      if (this.milestoneInfo.Job_TypeId !== null && this.milestoneInfo.Job_TypeId !== undefined) {
        getMilestoneCodeList({ Job_TypeId: this.milestoneInfo.Job_TypeId, lang: this.$ls.get('lang'), Terms: this.milestoneInfo.Terms }).then((res) => {
          const allData = res.data;
          allData.forEach((e) => {
            this.data.push({
              key: e.id,
              label: e.text,
            });
          });
        });
      }
    },
    submitForm() {
      if (this.checkedItems == null || this.checkedItems.length == 0) {
        this.$message({
          message: i18n.t('TankService.Content11'),
          type: 'warning'
        });
      } else {
        this.$refs.milestoneForm.validate(async (valid) => {
          if (valid) {
            this.submitLoading = true;
            if (this.milestoneInfo.Type == '1') {
              this.milestoneForm.CustomerCode = this.milestoneInfo.CustomerCode;
              this.milestoneForm.CustomerName = this.milestoneInfo.CustomerName;
            }
            this.milestoneForm.SelectMltCode = this.checkedItems.toString();
            this.milestoneForm.Job_TypeId = this.milestoneInfo.Job_TypeId;
            const queryData = {
              ...this.milestoneForm,
            };
            await saveMilestoneMan(queryData)
              .then((res) => {
                if (res && res.code === '200' && res.message === null) {
                  this.milestoneDialogVisible = false;
                  this.submitLoading = false;
                  this.$emit('submit');
                  this.checkedItems = [];
                  this.$message({
                    message: i18n.t('TankService.Content7'),
                    type: 'success'
                  });
                } else {
                  this.$message.error(res.message);
                  this.submitLoading = false;
                }
              })
          } else {
            return false;
          }
        });
      }
    },
    async onDialogOpen() {
      this.checkedItems = [];
      if (this.milestoneInfo && this.milestoneInfo.Booking_No) {
        this.resetmilestoneForm()
        this.milestoneForm = {
          ...this.milestoneInfo
        }
      }
      if (this.milestoneForm.SelectMltCode) {
        const milestoneCode = this.milestoneForm.SelectMltCode.split(',')
        for (let i = 0; i <= milestoneCode.length; i++) {
          if (milestoneCode[i] != '') {
            if (!this.checkedItems.includes(milestoneCode[i])) {
              this.checkedItems.push(milestoneCode[i]);
            }
          }
        }
      }
      this.$nextTick(() => {
        this.$refs.milestoneForm.clearValidate();
      });
    },
    handleClose() { },
    afterDialogClosed() {
      this.resetmilestoneForm();
      this.$refs.milestoneForm.resetFields();
    },
    resetmilestoneForm() {
      this.checkedItems = []
      this.milestoneForm = {
        Booking_No: '',
        MailTo: '',
        MailCC: '',
        MailSubject: '',
        MailBody: '',
        SelectMltCode: '',
        Job_TypeId: '',
        CustomerCode: '',
        CustomerName: '',
      };
    }
  },
};
</script>

<style lang="less">
.order-step {
  display: flex;
  justify-content: center;
  img {
    width: 34px;
    height: 34px;
    display: inline-block;
    margin-right: 8px;
  }
  .order-step-item {
    margin-right: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .satus-name {
    text-align: center;
    margin-top: 2px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .name {
      font-size: 12px;
      font-weight: 600;
      color: #111827;
    }
    .grey-name {
      font-size: 12px;
      font-weight: 600;
      color: #9ca3af;
    }
    .circular-ring {
      width: 9px;
      height: 9px;
      background-color: #ffffff;
      border-radius: 50%;
    }
  }
  .status-time {
    font-size: 15px;
    font-weight: 500;
    color: #9ca3af;
    line-height: 30px;
    color: #51abc3;
  }
}
.milestone-info-dialog {
  .milestone-form-container {
    justify-content: center;
    width: 100%;
    .el-form-item {
      &.is-error {
        margin-bottom: 16px;
        .el-form-item__error {
          left: 16px;
        }
      }
    }
    .el-cascader {
      width: 100%;
    }
    .el-input__inner {
      max-width: 600px;
    }
  }
  .detailBox {
    border: 0px solid #000;
    margin-left: 1px;
    padding: 1px;
    .el-transfer-panel {
      width: 250px;
    }
  }
  .dianRed {
    color: #e66c68;
  }
  .el-dialog--center .el-dialog__body {
    text-align: initial;
    padding: 5px 5px 5px;
  }
  .el-dialog--center .el-dialog__footer {
    text-align: inherit;
    padding: 5px 5px 5px;
  }
  .checkbox {
    zoom: 120%;
  }
}
</style>
